export { default } from "./CardShort"
